import { inject, Injectable } from '@angular/core';
import { LocalTokens } from '../../enums/local-tokens.enum';
import { LoginInfo } from '../../interfaces/login-info.interface';
import { EncryptionService } from '../encryption/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private encryptionService = inject(EncryptionService);

  constructor() { }

  // Clear local storage
  public clearLocalStorage() {
    localStorage.clear();
  }

  // LOGIN_INFO
  public setLoginInfo(loginInfo: LoginInfo) {
    const cipher: string = this.encryptionService.encrypt(JSON.stringify(loginInfo));
    // localStorage.setItem(LocalTokens.LOGIN_INFO, JSON.stringify(loginInfo));
    localStorage.setItem(LocalTokens.LOGIN_INFO, cipher.toString());
  }

  public getLoginInfo() {
    const cipher: string = localStorage.getItem(LocalTokens.LOGIN_INFO)?.toString() || "";
    const dataString: string = this.encryptionService.decrypt(cipher);
    // return JSON.parse(localStorage.getItem(LocalTokens.LOGIN_INFO)?.toString() || '{}');
    return JSON.parse(dataString || '{}');
  }

}
